import React, { useState } from 'react';
import Background from '../Components/Background/Background';
import Navbar from '../Components/Navbar/Navbar';
import { Hero } from '../Components/Hero/Hero';
import Home1 from '../Components/Section/Home1';
import Footer from '../Components/Footer/Footer';
import Home2 from '../Components/Section/Home2';

const Home = () => {
  let HeroData = [
    { Text1: 'Building trainers and ', Text2: 'creating a better tomorrow.' },

  ];

  const [HeroCount, setHeroCount] = useState(0);
  const [PlayState, setPlayState] = useState(true); // Set PlayState to true initially to display the background image

  return (
    <div>
      <Background PlayState={PlayState} HeroCount={HeroCount} />
      <Navbar/>
      <div style={{ width: '20px', height: '100px' }}></div>

      <Hero heroData={HeroData} /> {/* Pass HeroData to the Hero component */}
      <div style={{ width: '20px', height: '170px' }}></div>

      <Home1/>
      <Footer/>
    </div>
  );
}

export default Home;
